import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  Http,
  SettingsInputAntenna,
  DataObject,
  Timer,
  CheckCircle,
  Error,
  Cloud,
  Edit // ← Adicionar o ícone de edição
} from "@mui/icons-material";
import React, { memo, useState } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { useTheme } from "@material-ui/core/styles";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();

  // Obter ícone baseado no método HTTP
  const getMethodIcon = (method) => {
    switch(method?.toUpperCase()) {
      case 'GET': return <Http sx={{ width: "14px", height: "14px", color: "#10b981" }} />;
      case 'POST': return <DataObject sx={{ width: "14px", height: "14px", color: "#3b82f6" }} />;
      case 'PUT': return <SettingsInputAntenna sx={{ width: "14px", height: "14px", color: "#f59e0b" }} />;
      case 'DELETE': return <Delete sx={{ width: "14px", height: "14px", color: "#ef4444" }} />;
      case 'PATCH': return <Http sx={{ width: "14px", height: "14px", color: "#8b5cf6" }} />;
      default: return <Http sx={{ width: "14px", height: "14px", color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280" }} />;
    }
  };

  // Obter cor baseada no método HTTP
  const getMethodColor = (method) => {
    switch(method?.toUpperCase()) {
      case 'GET': return '#10b981';
      case 'POST': return '#3b82f6';
      case 'PUT': return '#f59e0b';
      case 'DELETE': return '#ef4444';
      case 'PATCH': return '#8b5cf6';
      default: return theme.palette.type === 'dark' ? "#9ca3af" : '#6b7280';
    }
  };

  // Obter cor do status
  const getStatusColor = (status) => {
    if (!status) return theme.palette.type === 'dark' ? "#9ca3af" : '#6b7280';
    if (status >= 200 && status < 300) return '#10b981';
    if (status >= 400 && status < 500) return '#f59e0b';
    if (status >= 500) return '#ef4444';
    return theme.palette.type === 'dark' ? "#9ca3af" : '#6b7280';
  };

  // Formatar URL para exibição
  const formatURL = (url) => {
    if (!url) return 'Nenhuma URL configurada';
    if (url.length > 40) {
      return url.substring(0, 37) + '...';
    }
    return url;
  };

  // Obter status simplificado
  const getStatusText = (status) => {
    if (!status) return 'Não executado';
    if (status >= 200 && status < 300) return 'Sucesso';
    if (status >= 400 && status < 500) return 'Erro Cliente';
    if (status >= 500) return 'Erro Servidor';
    return 'Desconhecido';
  };

  // Função para abrir modal de edição
  const handleEditClick = () => {
    storageItems.setNodesStorage(id);
    storageItems.setAct("edit"); // Ação de edição
  };

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: theme.palette.type === 'dark' ? "#262626" : "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        maxWidth: "320px",
        minWidth: "320px",
        width: "320px",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: `2px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.12)" : "#e5e7eb"}`,
        boxShadow: isHovered 
          ? "0 12px 32px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(59, 130, 246, 0.1)"
          : "0 4px 16px rgba(0, 0, 0, 0.06)",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        transform: isHovered ? "translateY(-2px)" : "translateY(0px)",
        pointerEvents: "auto",
        userSelect: "none",
      }}
    >
      {/* Target Handle */}
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(135deg, #3b82f6, #2563eb)",
          width: "16px",
          height: "16px",
          top: "24px",
          left: "-10px",
          cursor: 'pointer',
          border: `3px solid ${theme.palette.type === 'dark' ? "#262626" : "#ffffff"}`,
          boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "8px",
            height: "8px",
            marginLeft: "2.5px",
            marginBottom: "0.5px",
            pointerEvents: "none"
          }}
        />
      </Handle>

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: "16px",
          top: "16px",
          cursor: "pointer",
          gap: "8px",
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {/* Botão de Edição */}
        <div
          onClick={handleEditClick}
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            backgroundColor: theme.palette.type === 'dark' ? "rgba(2, 132, 199, 0.1)" : "#f0f9ff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "rgba(2, 132, 199, 0.2)" : "#e0f2fe";
            e.target.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "rgba(2, 132, 199, 0.1)" : "#f0f9ff";
            e.target.style.transform = "scale(1)";
          }}
        >
          <Edit
            sx={{ 
              width: "14px", 
              height: "14px", 
              color: "#0284c7"
            }}
          />
        </div>

        {/* Botão de Duplicar */}
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "#444444" : "#e5e7eb";
            e.target.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "#333333" : "#f3f4f6";
            e.target.style.transform = "scale(1)";
          }}
        >
          <ContentCopy
            sx={{ 
              width: "14px", 
              height: "14px", 
              color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280"
            }}
          />
        </div>

        {/* Botão de Excluir */}
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            backgroundColor: theme.palette.type === 'dark' ? "rgba(239, 68, 68, 0.1)" : "#fef2f2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "rgba(239, 68, 68, 0.2)" : "#fee2e2";
            e.target.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "rgba(239, 68, 68, 0.1)" : "#fef2f2";
            e.target.style.transform = "scale(1)";
          }}
        >
          <Delete
            sx={{ 
              width: "14px", 
              height: "14px", 
              color: "#ef4444"
            }}
          />
        </div>
      </div>

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "16px",
          paddingBottom: "12px",
          borderBottom: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "#f3f4f6"}`,
        }}
      >
        <div
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "12px",
            boxShadow: "0 4px 12px rgba(139, 92, 246, 0.25)",
          }}
        >
          <SettingsInputAntenna
            sx={{
              width: "18px",
              height: "18px",
              color: "#ffffff",
            }}
          />
        </div>
        <div style={{ flex: 1 }}>
          <div 
            style={{ 
              color: theme.palette.type === 'dark' ? "#ffffff" : "#111827", 
              fontSize: "16px", 
              fontWeight: "700",
              lineHeight: "1.2",
              marginBottom: "2px",
              display: "flex",
              alignItems: "center",
              gap: "8px"
            }}
          >
            <span>API Request</span>
            {data.method && (
              <span
                style={{
                  backgroundColor: `${getMethodColor(data.method)}15`,
                  color: getMethodColor(data.method),
                  padding: "2px 8px",
                  borderRadius: "6px",
                  fontSize: "11px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  gap: "4px"
                }}
              >
                {getMethodIcon(data.method)}
                {data.method}
              </span>
            )}
          </div>
          <div 
            style={{ 
              color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280", 
              fontSize: "12px", 
              fontWeight: "500",
            }}
          >
            Requisição REST
          </div>
        </div>
      </div>

      {/* URL Display */}
      <div
        style={{
          marginBottom: "12px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            marginBottom: "4px",
          }}
        >
          <Cloud sx={{ width: "12px", height: "12px", color: theme.palette.type === 'dark' ? "#6b7280" : "#9ca3af" }} />
          <span style={{ color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280", fontSize: "11px", fontWeight: "600" }}>
            URL
          </span>
        </div>
        <div
          style={{
            color: theme.palette.type === 'dark' ? "#f9fafb" : "#374151",
            fontSize: "13px",
            lineHeight: "1.5",
            backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f9fafb",
            padding: "12px",
            borderRadius: "8px",
            border: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "#f3f4f6"}`,
            fontFamily: "'Fira Code', 'Consolas', monospace",
            wordBreak: "break-all",
            maxHeight: "60px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={data.url}
        >
          {formatURL(data.url)}
        </div>
      </div>

      {/* Request Details */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
          marginBottom: "16px",
        }}
      >
        {/* Status Card */}
        <div
          style={{
            backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f9fafb",
            padding: "10px",
            borderRadius: "8px",
            border: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "# f3f4f6"}`,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginBottom: "4px",
            }}
          >
            {data.status ? (
              data.status >= 200 && data.status < 300 ? (
                <CheckCircle sx={{ width: "12px", height: "12px", color: "#10b981" }} />
              ) : (
                <Error sx={{ width: "12px", height: "12px", color: getStatusColor(data.status) }} />
              )
            ) : (
              <Timer sx={{ width: "12px", height: "12px", color: theme.palette.type === 'dark' ? "#6b7280" : "#9ca3af" }} />
            )}
            <span style={{ color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280", fontSize: "11px", fontWeight: "600" }}>
              Status
            </span>
          </div>
          <div
            style={{
              color: getStatusColor(data.status),
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            {data.status ? `${data.status} - ${getStatusText(data.status)}` : '--'}
          </div>
        </div>

        {/* Response Time Card */}
        <div
          style={{
            backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f9fafb",
            padding: "10px",
            borderRadius: "8px",
            border: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "# f3f4f6"}`,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginBottom: "4px",
            }}
          >
            <Timer sx={{ width: "12px", height: "12px", color: theme.palette.type === 'dark' ? "#6b7280" : "#9ca3af" }} />
            <span style={{ color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280", fontSize: "11px", fontWeight: "600" }}>
              Tempo
            </span>
          </div>
          <div
            style={{
              color: theme.palette.type === 'dark' ? "#f9fafb" : "#374151",
              fontSize: "14px",
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            {data.responseTime ? `${data.responseTime}ms` : '--'}
          </div>
        </div>
      </div>

      {/* Headers Count */}
      {data.headers && data.headers.length > 0 && (
        <div
          style={{
            marginBottom: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginBottom: "4px",
            }}
          >
            <DataObject sx={{ width: "12px", height: "12px", color: theme.palette.type === 'dark' ? "#6b7280" : "#9ca3af" }} />
            <span style={{ color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280", fontSize: "11px", fontWeight: "600" }}>
              Headers
            </span>
            <span
              style={{
                backgroundColor: theme.palette.type === 'dark' ? "#444444" : "#e5e7eb",
                color: theme.palette.type === 'dark' ? "#f9fafb" : "#374151",
                padding: "2px 6px",
                borderRadius: "12px",
                fontSize: "10px",
                fontWeight: "600",
                marginLeft: "auto",
              }}
            >
              {data.headers.length}
            </span>
          </div>
          <div
            style={{
              color: theme.palette.type === 'dark' ? "#f9fafb" : "#374151",
              fontSize: "12px",
              lineHeight: "1.5",
              backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f9fafb",
              padding: "8px 12px",
              borderRadius: "8px",
              border: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "# f3f4f6"}`,
              maxHeight: "40px",
              overflow: "hidden",
            }}
          >
            {data.headers.slice(0, 2).map((header, idx) => (
              <div key={idx} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ color: "#8b5cf6", fontWeight: "500" }}>{header.key}:</span>
                <span style={{ color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280" }}>{header.value}</span>
              </div>
            ))}
            {data.headers.length > 2 && (
              <div style={{ color: theme.palette.type === 'dark' ? "#6b7280" : "#9ca3af", fontSize: "11px", marginTop: "4px" }}>
                +{data.headers.length - 2} mais...
              </div>
            )}
          </div>
        </div>
      )}

      {/* Body Preview */}
      {data.body && data.bodyType && (
        <div
          style={{
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              marginBottom: "4px",
            }}
          >
            <Http sx={{ width: "12px", height: "12px", color: theme.palette.type === 'dark' ? "#6b7280" : "#9ca3af" }} />
            <span style={{ color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280", fontSize: "11px", fontWeight: "600" }}>
              Body ({data.bodyType})
            </span>
          </div>
          <div
            style={{
              color: theme.palette.type === 'dark' ? "#f9fafb" : "#374151",
              fontSize: "12px",
              lineHeight: "1.5",
              backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f9fafb",
              padding: "8px 12px",
              borderRadius: "8px",
              border: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "# f3f4f6"}`,
              maxHeight: "60px",
              overflow: "hidden",
              fontFamily: data.bodyType === 'json' ? "'Fira Code', 'Consolas', monospace" : "inherit",
              whiteSpace: "pre-wrap",
              wordBreak: "break-all",
            }}
          >
            {data.bodyType === 'json' 
              ? (() => {
                  try {
                    const parsed = JSON.parse(data.body || '{}');
                    return JSON.stringify(parsed, null, 2).substring(0, 100) + (data.body.length > 100 ? '...' : '');
                  } catch (e) {
                    return 'JSON inválido';
                  }
                })()
              : data.body.substring(0, 100) + (data.body.length > 100 ? '...' : '')
            }
          </div>
        </div>
      )}

      {/* Footer Info */}
      <div
        style={{
          paddingTop: "12px",
          borderTop: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "# f3f4f6"}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            fontSize: "11px",
            color: "#9ca3af",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
          }}
        >
          <SettingsInputAntenna sx={{ width: "12px", height: "12px", marginRight: "4px" }} />
          Componente API
        </div>
        {data.lastExecuted && (
          <div
            style={{
              fontSize: "10px",
              color: "#9ca3af",
              fontWeight: "500",
              backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f3f4f6",
              padding: "2px 6px",
              borderRadius: "8px",
            }}
            title={`Última execução: ${new Date(data.lastExecuted).toLocaleString()}`}
          >
            {new Date(data.lastExecuted).toLocaleDateString()}
          </div>
        )}
      </div>

      {/* Source Handle */}
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
          width: "16px",
          height: "16px",
          right: "-10px",
          top: "50%",
          cursor: 'pointer',
          border: `3px solid ${theme.palette.type === 'dark' ? "#262626" : "#ffffff"}`,
          boxShadow: "0 2px 8px rgba(139, 92, 246, 0.3)",
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "8px",
            height: "8px",
            marginLeft: "2px",
            marginBottom: "0.5px",
            pointerEvents: "none"
          }}
        />
      </Handle>
    </div>
  );
});